(function accordionInit() {
 if (document.readyState === 'loading') {
   return document.addEventListener('DOMContentLoaded', accordionInit);
 }


 var acc = document.getElementById('native-pdp-accordion');
 if (!acc || acc.dataset.accReady === '1') return;
 acc.dataset.accReady = '1';


 document.body.classList.add('accordion-revamp');


 var heads = Array.prototype.slice.call(acc.querySelectorAll('.acc-head'));
 var pages = Array.prototype.slice.call(acc.querySelectorAll('.acc-panel'));


 var openIdx = 0;


 // Height of whatever is currently pinned to the top of the viewport (sticky
 // header, plus any promo/shipping bar stacked above it) — getBoundingClientRect
 // already reflects any offset those bars push the header down by, so this is
 // the full occluded height regardless of how many bars are stacked.
 function stickyOffset() {
   var el = document.getElementById('shopify-section-header');
   // The header element itself is static on this theme; the pinned element is
   // an ancestor (.cc-top-sticky), so walk up to the nearest fixed/sticky one.
   while (el && el !== document.body) {
     var pos = window.getComputedStyle(el).position;
     if (pos === 'fixed' || pos === 'sticky') return el.getBoundingClientRect().bottom;
     el = el.parentElement;
   }
   return 0;
 }

 // Scrolls so the top of the accordion wrapper sits just under the sticky
 // header, whichever tab was opened (mobile and desktop).
 function scrollToTab() {
   var target = acc.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
   window.scrollTo({ top: target, behavior: 'smooth' });
 }

 // Opens a tab without the toggle-closes-if-already-open behavior below —
 // used by the review-badge shortcut (assets/pdp-reviews.js) so clicking it
 // again while the reviews tab is already open re-scrolls instead of closing it.
 function openTab(idx) {
   if (openIdx !== idx) {
     heads.forEach(function(h) { h.classList.remove('active'); });
     pages.forEach(function(p) { p.classList.remove('active'); });
     openIdx = idx;
     heads[idx].classList.add('active');
     pages[idx].classList.add('active');
   }
   scrollToTab();
 }
 window.pdpOpenAccordionTab = function (headSelector) {
   var idx = heads.findIndex(function(h) { return h.matches(headSelector); });
   if (idx !== -1) openTab(idx);
 };

 heads.forEach(function(head, idx) {
   head.addEventListener('click', function(e) {
     e.stopPropagation();
     var wasOpen = (openIdx === idx);
     heads.forEach(function(h) { h.classList.remove('active'); });
     pages.forEach(function(p) { p.classList.remove('active'); });
     if (wasOpen) {
       openIdx = -1;
     } else {
       openIdx = idx;
       heads[idx].classList.add('active');
       pages[idx].classList.add('active');
     }
     try { campaign.trigger('Clicked.' + head.textContent.trim()); } catch(e2) {}
     if (!wasOpen) scrollToTab();
   });
 });


 var openFaqIdx = -1;
 Array.prototype.slice.call(acc.querySelectorAll('.faq-link')).forEach(function(link, faqIdx) {
   link.addEventListener('click', function(e) {
     e.stopPropagation();
     var li = link.parentElement;
     var siblings = Array.prototype.slice.call(li.parentElement.children);
     var wasOpen = (openFaqIdx === faqIdx);
     siblings.forEach(function(s) { s.classList.remove('faq-active'); });
     openFaqIdx = -1;
     if (!wasOpen) {
       li.classList.add('faq-active');
       openFaqIdx = faqIdx;
     }
     try { campaign.trigger('Clicked.' + link.textContent.trim()); } catch(e2) {}
     window.scrollTo(0, acc.getBoundingClientRect().top + window.pageYOffset);
   });
 });


 var sectionId = acc.getAttribute('data-section-id');
 var cartBtn = document.getElementById('AddToCart-' + sectionId);
 if (cartBtn) {
   cartBtn.addEventListener('click', function() {
     try { campaign.trigger('Clicked.addtocart'); } catch(e) {}
   });
 }


 var descEl = acc.querySelector('#tab-1 .acc-description');
 if (descEl && !descEl.querySelector('.desc-text')) {
   var full = descEl.innerHTML;
   descEl.innerHTML = '<div class="desc-text">' + full + '</div><span class="read-toggle">Read More</span>';
   var textEl   = descEl.querySelector('.desc-text');
   var toggleEl = descEl.querySelector('.read-toggle');
   setTimeout(function() {
     if (textEl.scrollHeight <= textEl.offsetHeight) toggleEl.style.display = 'none';
   }, 100);
   toggleEl.addEventListener('click', function() {
     if (textEl.classList.contains('expanded')) {
       textEl.classList.remove('expanded');
       toggleEl.textContent = 'Read More';
       try { campaign.trigger('Clicked.Read Less'); } catch(e) {}
       textEl.scrollTop = 0;
       window.scrollTo({ top: descEl.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
     } else {
       textEl.classList.add('expanded');
       toggleEl.textContent = 'Read Less';
       try { campaign.trigger('Clicked.Read More'); } catch(e) {}
     }
   });
 }
})();


